import { useStaticDataTypeList } from '@/features/logs-management/static-data-type/hooks/useStaticDataTypeList';
import { StaticDataTypeTable } from '@/features/logs-management/static-data-type/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortStaticDataSchema = z.object({
  id: z.enum(['staticDataTypeName', 'staticDataTypeDescription']),
  desc: z.boolean(),
});

const staticDataSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortStaticDataSchema))
    .optional(),
  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/logs-management/static-data-type/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => staticDataSchema.parse(search),
});

function RouteComponent() {
  const { staticDataType, isLoading, pagination } = useStaticDataTypeList();
  return <StaticDataTypeTable data={staticDataType} isLoading={isLoading} pagination={pagination} />;
}
